import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import { Box } from "@mui/system"

const sharedStrongBlue = ({ theme }) => ({
  color: theme.palette.primary["700"],
  marginRight: 10
})

const sharedStrongGreen = ({ theme }) => ({
  color: theme.palette.success["main"],
  marginRight: 10
})

const sharedStrongRed = ({ theme }) => ({
  color: theme.palette.error["main"],
  marginRight: 10
})

export const StyledDateTypography = styled(Typography)(({ theme }) => ({
  margin: "3px 14px 16px 14px",
  color: theme.palette.error.main,
  fontSize: "0.75rem"
}))

export const StyledBlueIcon = styled(FontAwesomeIcon)(sharedStrongBlue)
export const StyledBlueText = styled(Typography)(sharedStrongBlue)
export const StyledGreenIcon = styled(FontAwesomeIcon)(sharedStrongGreen)
export const StyledGreenText = styled(Typography)(sharedStrongGreen)
export const StyledRedIcon = styled(FontAwesomeIcon)(sharedStrongRed)
export const StyledRedText = styled(Typography)(sharedStrongRed)
export const StyledWrapBox = styled(Box)(({ theme, themeData }) => ({
  backgroundColor: themeData,
  borderRadius: "10px"
}))
